import api from "../config/api";
import { Notification } from "../models/Notification";
import { ServiceReturn } from "../types/ServiceResponse";

export interface NotificationsPayload {
  results: Array<Notification>;
  unreadCount: number;
  total: number;
  page: number;
  perPage: number;
};

export interface GetNotificationsPayload {
  page?: number;
  perPage?: number;
};

const moduleBaseUrl = "notification";

export const normalizeNotification = ( notification: Notification ): Notification => ({
  ...notification,
  readAt: notification.readAt ? new Date( notification.readAt ) : notification.readAt,
  createdAt: new Date( notification.createdAt ),
  updatedAt: new Date( notification.updatedAt ),
});

export const getNotifications = async ({ page = 1, perPage = 20 }: GetNotificationsPayload = {}, token?: string ): Promise<ServiceReturn<NotificationsPayload>> => {
  try {
    const { data } = await api.get(`/${ moduleBaseUrl }`, {
      headers: {
        Authorization: `Bearer ${ token }`,
      },
      params: {
        page,
        perPage,
      },
    });

    if( data?.data ) {
      data.data.results = Array.isArray( data.data.results )
        ? data.data.results.map( normalizeNotification )
        : [];
      data.data.unreadCount = Number( data.data.unreadCount ?? 0 );
      data.data.total = Number( data.data.total ?? data.data.results.length );
      data.data.page = Number( data.data.page ?? page );
      data.data.perPage = Number( data.data.perPage ?? perPage );
    }

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};

export const markNotificationRead = async ( notificationId: string, token?: string ): Promise<ServiceReturn<Notification>> => {
  try {
    const { data } = await api.patch(`/${ moduleBaseUrl }/${ notificationId }/read`, {}, {
      headers: {
        Authorization: `Bearer ${ token }`,
      },
    });

    if( data?.data ) data.data = normalizeNotification( data.data );

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};
